import { render, staticRenderFns } from "./AppointmentAnamnesis.vue?vue&type=template&id=64cd0e72"
import script from "./AppointmentAnamnesis.vue?vue&type=script&lang=js"
export * from "./AppointmentAnamnesis.vue?vue&type=script&lang=js"
import style0 from "./AppointmentAnamnesis.vue?vue&type=style&index=0&id=64cd0e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports